import React from "react";
import { Modal, ModalBody, Spinner, ModalHeader, Row, Col } from "reactstrap";
import { FaCheck, FaPause } from "react-icons/fa";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { mintProgressReset } from "../../../redux/contracts";

const TransactionProgressModal = (
  {
    transactionInProgress,
    awaitingTransactionConfirmation,
    transactionPending,
    progressHeading,
  },
  context
) => {
  const dispatch = useDispatch();

  return (
    <Modal
      isOpen={
        awaitingTransactionConfirmation ||
        transactionInProgress ||
        transactionPending
      }
      toggle={() => dispatch(mintProgressReset())}
      centered
    >
      <ModalHeader toggle={() => dispatch(mintProgressReset())}>
        {progressHeading ? progressHeading : context.t("Purchase in Progress")}
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col xs={2} className="text-center">
            {awaitingTransactionConfirmation ? (
              <Spinner
                style={{ width: "1rem", height: "1rem" }}
                color="primary"
              />
            ) : (
              <FaCheck size={"1rem"} className="text-primary" />
            )}
          </Col>
          <Col xs={10}>
            <p className="h5 fw-bold">
              {context.t("Signing with your wallet")}
            </p>
            <p>
              {awaitingTransactionConfirmation
                ? context.t(
                    "Please follow your wallet instructions to confirm the transaction."
                  )
                : context.t("You confirmed the transaction with your wallet.")}
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={2} className="text-center">
            {awaitingTransactionConfirmation ? (
              <FaPause size={"1rem"} className="text-muted" />
            ) : (
              <>
                {transactionInProgress ? (
                  <Spinner
                    style={{ width: "1rem", height: "1rem" }}
                    color="primary"
                  />
                ) : (
                  <FaCheck size={"1rem"} className="text-primary" />
                )}
              </>
            )}
          </Col>
          <Col
            xs={10}
            className={awaitingTransactionConfirmation && "text-muted"}
          >
            <p className="h5 fw-bold">
              {context.t("Transaction is sent to the blockchain")}
            </p>
            <p>
              {context.t(
                "After signing the transaction it is send to the blockchain."
              )}
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={2} className="text-center">
            {awaitingTransactionConfirmation || transactionInProgress ? (
              <FaPause size={"1rem"} className="text-muted" />
            ) : (
              <>
                {transactionPending ? (
                  <Spinner
                    style={{ width: "1rem", height: "1rem" }}
                    color="primary"
                  />
                ) : (
                  <FaCheck size={"1rem"} className="text-primary" />
                )}
              </>
            )}
          </Col>
          <Col xs={10} className={!transactionPending && "text-muted"}>
            <p className="h5 fw-bold">
              {context.t("Transaction is being processed")}
            </p>
            <p>
              {context.t(
                "Please check your wallets transaction history for your actual transaction status!"
              )}
            </p>
          </Col>
        </Row>
        {transactionPending && (
          <p>
            {context.t(
              "You can close this modal at any time - it does not affect your transaction. We will close the modal for you once we see that the transaction is mined."
            )}
          </p>
        )}
      </ModalBody>
    </Modal>
  );
};

/**  define proptype for the 'translation' function  */
TransactionProgressModal.contextTypes = {
  t: PropTypes.func,
};

TransactionProgressModal.propTypes = {
  transactionInProgress: PropTypes.bool,
  awaitingTransactionConfirmation: PropTypes.bool,
  transactionPending: PropTypes.bool,
  progressHeading: PropTypes.string,
};

TransactionProgressModal.defaultProps = {};

export default TransactionProgressModal;
